import React from 'react';
import { Phone, MessageCircle } from 'lucide-react';

const FloatingContactButtons = () => {
  const handleWhatsAppClick = () => {
    const phoneNumber = '917998666660';
    const message = encodeURIComponent('Hi, I would like to inquire about your taxi services.');
    window.open(`https://wa.me/${phoneNumber}?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.location.href = 'tel:+917998666660';
  };

  return (
    <>
      {/* WhatsApp Button - Left Side - Mobile Only */}
      <button
        onClick={handleWhatsAppClick}
        className="fixed left-3 sm:left-4 bottom-3 sm:bottom-4 z-50 w-12 h-12 sm:w-14 sm:h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 lg:hidden touch-manipulation"
        style={{
          background: 'linear-gradient(135deg, #25D366 0%, #128C7E 50%, #25D366 100%)',
          backgroundSize: '200% 200%',
          animation: 'gradientPulseWhatsApp 3s ease-in-out infinite'
        }}
        aria-label="Contact via WhatsApp"
      >
        <MessageCircle className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
      </button>

      {/* Call Button - Right Side - Mobile Only */}
      <button
        onClick={handleCallClick}
        className="fixed right-3 sm:right-4 bottom-3 sm:bottom-4 z-50 w-12 h-12 sm:w-14 sm:h-14 rounded-full shadow-lg flex items-center justify-center transition-all duration-300 hover:scale-110 active:scale-95 lg:hidden touch-manipulation"
        style={{
          background: 'linear-gradient(135deg, #0D9488 0%, #14B8A6 50%, #0D9488 100%)',
          backgroundSize: '200% 200%',
          animation: 'gradientPulseCall 3s ease-in-out infinite'
        }}
        aria-label="Call us"
      >
        <Phone className="w-6 h-6 sm:w-7 sm:h-7 text-white" />
      </button>
    </>
  );
};

export default FloatingContactButtons;